// extracted by mini-css-extract-plugin
export default {"sentinel":"Sentinel_style__sentinel___ca"};